webpackJsonp([45506126157717],{

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FrequentQuestions = function (_React$Component) {
	  _inherits(FrequentQuestions, _React$Component);
	
	  function FrequentQuestions(props) {
	    _classCallCheck(this, FrequentQuestions);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleClick = function (index) {
	      _this.setState({
	        collapsibleOpen: !_this.state.collapsibleOpen,
	        collapsibleId: index
	      });
	    };
	
	    _this.state = {
	      collapsibleOpen: false,
	      collapsibleId: null
	    };
	    return _this;
	  }
	
	  FrequentQuestions.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'section',
	      { className: 'section-faq purple-bg', id: 'section-faq' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container container-1010' },
	        _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'h-80 p-white m-0' },
	            'Frequently Asked Questions'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'faq mt-70', id: 'accordion' },
	          this.props.data.map(function (_ref, index) {
	            var question = _ref.question,
	                answer = _ref.answer;
	            return _react2.default.createElement(
	              'div',
	              { className: 'collapsible-group' },
	              _react2.default.createElement(
	                'div',
	                { className: 'collapsible-heading', role: 'tab', id: 'headingOne' },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    role: 'button',
	                    className: _this2.state.collapsibleOpen && _this2.state.collapsibleId === index ? '' : 'collapsed',
	                    'data-parent': '#accordion',
	                    href: 'javascript:void(0)',
	                    onClick: function onClick() {
	                      return _this2.handleClick(index);
	                    }
	                  },
	                  question,
	                  _react2.default.createElement('span', { className: 'collapsible-sign' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { id: index, className: _this2.state.collapsibleOpen && _this2.state.collapsibleId === index ? 'collapsible-collapse collapse in' : 'collapsible-collapse collapse' },
	                _react2.default.createElement('div', { className: 'collapsible-body', dangerouslySetInnerHTML: { __html: answer } })
	              )
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return FrequentQuestions;
	}(_react2.default.Component);
	
	FrequentQuestions.propTypes = {
	  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    question: _propTypes2.default.string,
	    answer: _propTypes2.default.string
	  }))
	};
	
	exports.default = FrequentQuestions;
	module.exports = exports['default'];

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.jobseekersPageQuery = exports.JobseekersPageTemplate = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FrequentQuestions = __webpack_require__(114);
	
	var _FrequentQuestions2 = _interopRequireDefault(_FrequentQuestions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JobseekersPageTemplate = exports.JobseekersPageTemplate = function JobseekersPageTemplate(_ref) {
	  var title = _ref.title,
	      frequentQuestions = _ref.frequentQuestions,
	      html = _ref.html;
	
	  return _react2.default.createElement(
	    'main',
	    { id: 'main', className: 'site-main' },
	    _react2.default.createElement('div', {
	      className: 'jobseekers-content',
	      dangerouslySetInnerHTML: { __html: html }
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'hero hero-subpage strong-overlay' },
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-content text-center' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container container-650' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'h-80 weight-bold weight-light' },
	            title
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'section-steps' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container container-650' },
	          _react2.default.createElement(
	            'div',
	            { className: 'steps' },
	            _react2.default.createElement(
	              'div',
	              { className: 'step' },
	              _react2.default.createElement(
	                'div',
	                { className: 'circle step-thumb' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'h-72 p-purple weight-light' },
	                  '1'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'step-info' },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'p-24 weight-bold p-purple' },
	                  'Create a Profile'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'p-18 p-gray' },
	                  'Join at ',
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://jobs.swissmonkey.io/register' },
	                    'https://jobs.swissmonkey.io/register'
	                  ),
	                  ' or download the free Swiss Monkey app directly to your phone and create your own unique profile. Dental-specific fields make it easy and fast to create a profile from your mobile device.  If you\u2019re open to temping, include specific days or times!'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'step' },
	              _react2.default.createElement(
	                'div',
	                { className: 'circle step-thumb' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'h-72 p-purple weight-light' },
	                  '2'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'step-info' },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'p-24 weight-bold p-purple' },
	                  'Receive Job Notifications and Messages'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'p-18 p-gray' },
	                  'Job openings are sent in real-time directly to your phone so you can review and apply no matter where you are! Just press a button and submit your profile. Done and done! You can also apply directly to jobs. Doctors may also contact you directly about job opportunities so be sure your profile is up to date.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'step' },
	              _react2.default.createElement(
	                'div',
	                { className: 'circle step-thumb' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'h-72 p-purple weight-light' },
	                  '3'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'step-info' },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'p-24 weight-bold p-purple' },
	                  'Interview and Hire'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'p-18 p-gray' },
	                  'You\u2019re in control of when and where you want to work. You contract directly with employers so no additional fees are necessary if they want to hire you!'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center mt-70' },
	              _react2.default.createElement(
	                'a',
	                { href: 'https://itunes.apple.com/us/app/swiss-monkey/id1089425152?mt=8', className: 'btn-main btn-alt' },
	                'Download the app'
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_FrequentQuestions2.default, { data: frequentQuestions })
	  );
	};
	
	JobseekersPageTemplate.propTypes = {
	  title: _propTypes2.default.string.isRequired
	};
	
	var JobseekersPage = function JobseekersPage(_ref2) {
	  var data = _ref2.data;
	  var _data$markdownRemark = data.markdownRemark,
	      frontmatter = _data$markdownRemark.frontmatter,
	      html = _data$markdownRemark.html;
	
	
	  return _react2.default.createElement(JobseekersPageTemplate, {
	    html: html,
	    title: frontmatter.title,
	    frequentQuestions: frontmatter.frequentQuestions
	  });
	};
	
	JobseekersPage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = JobseekersPage;
	var jobseekersPageQuery = exports.jobseekersPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-jobseekers-page-js-4334ce3299cd8966171a.js